module.exports = __webpack_public_path__ + "media/images/help/wf-register-to-track-d740e4897013fdb31a5bbaaf91a9955c.png";